export default "__VITE_ASSET__8df9f59c__"